import React from "react";
import { IonList } from "@ionic/react";
import { PaymentNoticeCommentBox } from "./PaymentNoticeCommentBox";
import { PaymentNoticeMessages } from "./PaymentNoticeMessages";

export const SegmentMessages: React.FC = () => {
  return (
    <section>
      <br />
      <IonList style={{ minHeight: "144px" }}>
        <PaymentNoticeCommentBox />
      </IonList>
      <br />
      <IonList>
        <PaymentNoticeMessages />
      </IonList>
    </section>
  );
};
